export var AutoIgnitionState;
(function (AutoIgnitionState) {
    AutoIgnitionState["engine"] = "engine";
    AutoIgnitionState["webasto"] = "webasto";
    AutoIgnitionState["webasto-confirmed"] = "webasto-confirmed";
    AutoIgnitionState["enabled"] = "enabled";
    AutoIgnitionState["disabled"] = "disabled";
    AutoIgnitionState["enabling"] = "enabling";
    AutoIgnitionState["delay"] = "delay";
})(AutoIgnitionState || (AutoIgnitionState = {}));
